import Select from 'react-select';
import {
  AutomationRequest,
  AutomationType,
  AutomationTypesLabels
} from 'app/console-api/automations/types';
import React from 'react';
import { FlexColumn, FlexRow } from '@make-software/cspr-design';
import { DropdownStyles } from 'app/components/common/common-styles';
import styled from 'styled-components';
import { DateControl } from 'app/components/management/common/autoamtions/date-control';
import { TrafficTargetControl } from 'app/components/management/common/autoamtions/traffic-target-control';
import {
  AutomationOption,
  AutomationTypeControlProps
} from 'app/components/common/automation/utils';
import { mixed, number, object } from 'yup';
import {
  AutomationRegistry,
  getDefaultParamsByType
} from 'app/components/common/automation/registry';

const StyledAutomationRow = styled(FlexRow)`
  width: 100%;
  gap: 5px;
  align-items: flex-start;
`;

export const automationItemSchema = object({
  id: number().nullable(),
  type: mixed<AutomationType>()
    .oneOf(
      [AutomationType.TrafficTarget, AutomationType.DateStart, AutomationType.DateEnd],
      'Unsupported automation type'
    )
    .required('Automation type is required'),
  params: mixed().when('type', (values, schema, options) => {
    return AutomationRegistry[values[0] as AutomationType].validator || object();
  })
});

interface AutomationControlProps {
  index: number;
  automation: AutomationRequest;
  options: AutomationOption[];
  onChange: (next: AutomationRequest) => void;
  errors?: any;
}

const automationControlMap: Record<AutomationType, React.FC<AutomationTypeControlProps>> = {
  [AutomationType.TrafficTarget]: TrafficTargetControl,
  [AutomationType.DateStart]: DateControl,
  [AutomationType.DateEnd]: DateControl
};

export const AutomationControl = ({
  index,
  automation,
  options,
  onChange,
  errors
}: AutomationControlProps) => {
  const selectedOption = React.useMemo<AutomationOption>(
    () => ({
      value: automation.type,
      label: AutomationTypesLabels[automation.type]
    }),
    [automation.type]
  );
  const SelectedFormControls = automationControlMap[selectedOption.value];
  return (
    <StyledAutomationRow key={index}>
      <FlexColumn gap={10} style={{ flex: 1 }}>
        <Select
          key={index}
          options={options}
          value={selectedOption}
          styles={DropdownStyles()}
          onChange={(selected) => {
            const nextType = (selected as AutomationOption).value;
            onChange({
              ...automation,
              type: nextType,
              params: getDefaultParamsByType(nextType) // reset params on type change
            });
          }}
        />
        {SelectedFormControls && (
          <SelectedFormControls
            value={automation.params as any}
            onChange={(nextParams: any) => {
              onChange({
                ...automation,
                params: nextParams
              });
            }}
            errors={errors}
          />
        )}
      </FlexColumn>
    </StyledAutomationRow>
  );
};
